import { gql } from "lib/apolloClient";
import { unitFlowItem } from "./Fragments";

export const getUnitCombinedLibraryQuery = gql`
  query getUnitCombinedLibrary(
    $parentId: ID!
    $filters: LearningCourseFlowFilter
    $after: String
    $first: Int
  ) {
    node(id: $parentId, type: LEARNING_COURSE) {
      id
      ... on LearningCourse {
        id
        learningCourseFlowFeedWrapper {
          learningCourseFlowFeed(
            orderBy: CREATED_AT
            filters: $filters
            orderByDirection: DESC
            after: $after
            first: $first
          ) {
            edges {
              node {
                ...unitFlowItem
              }
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
              __typename
            }
            resourceBasedCount {
              totalCount
              __typename
            }
          }
        }
        __typename
      }
    }
  }
  ${unitFlowItem}
`;
